import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-brand">
          <span className="material-icons">memory</span>
          <span>uProject Lab</span>
        </div>
        <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <a href="#overview" className="nav-link" onClick={closeMenu}>Tổng quan</a>
          <a href="#projects" className="nav-link" onClick={closeMenu}>Dự án</a>
          <a href="#components" className="nav-link" onClick={closeMenu}>Linh kiện</a>
          <a href="#contact" className="nav-link" onClick={closeMenu}>Liên hệ</a>
          <a href="https://home.uproject.io.vn" target="_blank" rel="noopener noreferrer" className="nav-link nav-link-external">
            OTA-Dashboard
          </a>
        </div>
        <button className="nav-toggle" onClick={toggleMenu}>
          <span className="material-icons">{isMenuOpen ? 'close' : 'menu'}</span>
        </button>
      </nav>
    </header>
  );
};

export default Header;
